export const robotusecases = [

    {
        title: "E-commerce Customer Guide",
        details: "Our bot is designed to serve as a knowledgeable customer guide, equipped with extensive access to your inventory and product catalog. It excels in efficiently addressing customer inquiries, providing guidance, and swiftly resolving issues. Moreover, the bot can be trained to handle a variety of potential challenges your clients might encounter. Notably, any unresolved issues are automatically integrated into its database, ensuring continuous learning and improvement.",
        image: require('../images/eco.png'),
    }
    ,
    {
        title: "Customer Relationship Tool",
        details: "MdBot goes beyond being just a problem solver—it doubles as a customer relationship tool. It excels in maintaining and managing customer relationships, ensuring a seamless experience. In cases where immediate resolution isn't possible, MdBot is adept at efficiently directing issues to the appropriate sales agents, facilitating a swift and personalized response.",
        image: require('../images/chatbot.png'),
    }
    ,
    {
        title: "Medical Diagnosis Bot",
        details: "If MdBot is trained as a medical personnel, MdBot can accurately diagnose and direct the patient to the appropraiate doctor in charge. It however does not prescribe drug for the patient, just help with proper diagnostics. If combined with a medicine store it can also adequately inform the client of the drugs available in case of direct search.",
        image: require('../images/medical.png'),
    }
]